
export default {
  data() {
    return {
      editingPreventLeavePage: false
    }
  },
  beforeRouteLeave (to, from, next) {
    if(!this.$data.editingPreventLeavePage)
      return next(true)
    
    this.confirmMessage(`Cancel Editing?`, `You have unsaved changes, are you sure you want to leave?`)
    .then(success => {
      next(success)
    })
    .catch(function () {
      next(false)
    })
  },
  created() {
    window.addEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload)
  },
  methods: {
    onBeforeUnload: function(event) {
      if(!this.$data.editingPreventLeavePage)
        return null

      var confirmationMessage = `You have unsaved changes. Are you sure you want to exit?`

      event.returnValue = confirmationMessage
      return confirmationMessage
    },
  }
}